import { Flex } from '@chakra-ui/react';
import { ReactElement } from 'react';

import { PageManager } from '../PageManager';
import { TOOLBAR_HEIGHT, Toolbar } from '../Toolbar';
import { ZoomControl } from './ZoomControl';

export const PageControls = (): ReactElement => {
  return (
    <Flex direction={'row'} h={`${TOOLBAR_HEIGHT}px`}>
      <Toolbar />
      <ZoomControl />
      <PageManager />
    </Flex>
  );
};
